/* v8 ignore next */
const reportEvents = Object.freeze({
  STARTED: "STARTED",
  STOPPED: "STOPPED",
  REFUSED: "REFUSED",
  UNAVAILABLE: "UNAVAILABLE",
  COMMENT: "COMMENT",
  CONTINUATION: "CONTINUATION",
  BEHAVIOUR: "BEHAVIOUR",
});

/* v8 ignore next */
// @todo remove
const reportActions = Object.freeze({
  STARTED: "STARTED",
  STOPPED: "STOPPED",
  NOTE: "COMMENT",
  CONTINUATION: "CONTINUATION",
});

const unableToStartOptions = [
  {
    label: "Illness / sick",
    value: "illness",
    icon: "stethoscope",
    buttonClass: "btn-outline-danger text-start",
  },
  {
    label: "Asleep",
    value: "asleep",
    icon: "bed",
    buttonClass: "btn-outline-danger text-start",
  },
  {
    label: "Client not available",
    value: "not-available",
    icon: "user-slash",
    buttonClass: "btn-outline-danger text-start",
  },
  {
    label: "Client refused",
    value: "refused",
    icon: "hand",
    buttonClass: "btn-outline-danger text-start",
  },
];

const likertSatisfactionOptions = [
  {
    label: "Very Dissatisfied",
    value: 1,
    icon: "face-frown-open",
    color: "var(--likert-1-fg)",
  },
  {
    label: "Dissatisfied",
    value: 2,
    icon: "face-frown",
    color: "var(--likert-2-fg)",
  },
  {
    label: "Neutral",
    value: 3,
    icon: "face-meh",
    color: "var(--likert-3-fg)",
  },
  {
    label: "Satisfied",
    value: 4,
    icon: "face-smile",
    color: "var(--likert-4-fg)",
  },
  {
    label: "Very Satisfied",
    value: 5,
    icon: "face-smile-beam",
    color: "var(--likert-5-fg)",
  },
];

const activityPresentationOptions = [
  { label: "Low mood/concerned", value: "LOW_MOOD" },
  { label: "Wanting time to self", value: "TIME_TO_SELF" },
  { label: "Agitated and walking around", value: "AGITATED" },
  { label: "Not physically well", value: "NOT_WELL" },
  { label: "Happy and content", value: "HAPPY" },
  { label: "Other", value: "OTHER" },
];

/* v8 ignore next */
export {
  reportActions,
  reportEvents,
  unableToStartOptions,
  likertSatisfactionOptions,
  activityPresentationOptions,
};
